const defaultFirstName = 'NoFirstNameProvided';
const defaultLastName = 'NoLastNameProvided';

export { defaultFirstName, defaultLastName };
